import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const Row = ({
  children,
  className,
  isFullWidth,
  testSection,
  ...props
}) => {
  const mappedChildren = children.map((child, idx) => {
    const rowClassname = classNames({
      "flex--1": isFullWidth,
      "push-double--right": idx < children.length - 1
    });
    return /* @__PURE__ */ jsx("div", { className: rowClassname, children: child }, idx);
  });
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames("flex", className),
      "data-test-section": testSection,
      ...props,
      children: mappedChildren
    }
  );
};
Row.propTypes = {
  children: PropTypes.node.isRequired,
  /** CSS class names. */
  className: PropTypes.string,
  /** Indicates whether items in the row should take up as much width as possible */
  isFullWidth: PropTypes.bool,
  testSection: PropTypes.string
};

export { Row as default };
